import React, { useState, useEffect } from "react";
import FromNow from 'components/Time/FromNow';
import ClickOutside from 'react-click-outside';
import api from "api";
import ApiCaller from "api/apiCaller";

import "./index.css";

export default function NotiItem({ notification }) {
    const [isRead, setIsRead] = useState(notification.is_read);
    const markNotiAsRead = async () => {
        if (isRead == 0) {
            const res = await ApiCaller.post(`notification/read/${notification.id}`);
            if (res.status === 'ok') {
                setIsRead(true);
            }
        }
    }
    return (
        <div
            className={`noti_menu__item ${!isRead ? 'noti_menu__item-is-read' : ''}`}
            style={styles.container}
            onClick={markNotiAsRead}
        >
            <a
                className="noti_menu__item-link"
                href={notification.content?.url}
            >
                <div
                    style={styles.body}
                    dangerouslySetInnerHTML={{ __html: notification.content.html_content }}
                />
                <div>
                    <span style={styles.since}>
                        <FromNow value={notification.event_date} />
                    </span>
                </div>
            </a>
        </div>
    );
}

const styles = {
    container: {
        padding: 12,
        borderBottom: '1px solid var(--color-line)',
    },
    body: {
        fontSize: 14,
    },
    since: {
        fontSize: 12,
        color: 'var(--color-light-2)',
    },
}
